import categoriesJson from "../data/categories.json";

export const getAllCategories = () => {
  return categoriesJson;
};
